"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObservableAnimation = void 0;
class ObservableAnimation {
    _id;
    _data;
    _subscriptions;
    _currentValue;
    _progress;
    constructor(_id, _data) {
        this._id = _id;
        this._data = _data;
        this._subscriptions = new Map();
        const { object, property, values } = this._data;
        const current = object[property];
        if (!values.initial) {
            values.initial = current;
        }
        this._currentValue = values.initial;
        this._progress = 0;
    }
    on(event, callback, context) {
        const subscriptions = this._subscriptions.get(event);
        const bind = callback.bind(context);
        this._subscriptions.set(event, subscriptions ? [...subscriptions, bind] : [bind]);
        return this;
    }
    updateProgress() {
        this._progress++;
        if (this._progress >= this._data.duration) {
            this._emit('finish');
        }
    }
    update(value) {
        this._currentValue = value;
        this._emit('update');
    }
    interrupt() {
        this._emit('interruption');
    }
    finish() {
        this._emit('finish');
    }
    _emit(event) {
        for (const subscription of this._subscriptions.get(event) ?? []) {
            subscription(this);
        }
    }
    get id() {
        return this._id;
    }
    get data() {
        return this._data;
    }
    get progress() {
        return this._progress;
    }
}
exports.ObservableAnimation = ObservableAnimation;
